import { useMutation } from '@apollo/client';

import NEW_OFFLINE_SESSION from 'graphql/fragments/NewOfflineSession.graphql';
import CREATE_OR_UPDATE_OFFLINE_SESSION from 'graphql/mutations/offlineSessions/CreateOrUpdateOfflineSession.graphql';

export default function useCreateOrUpdateOfflineSessionMutation() {
  return useMutation(CREATE_OR_UPDATE_OFFLINE_SESSION, {
    update(cache, { data: { createOrUpdateOfflineSession } }) {
      const offlineSession = createOrUpdateOfflineSession?.offlineSession;

      cache.modify({
        fields: {
          offlineSessionsByEpub(existingOfflineSessions) {
            let edges = existingOfflineSessions.edges;

            if (offlineSession) {
              edges = existingOfflineSessions.edges.filter(
                (edge) => edge.node.id !== offlineSession.id,
              );

              const newOfflineSessionRef = cache.writeFragment({
                data: offlineSession,
                fragment: NEW_OFFLINE_SESSION,
              });

              edges.push({
                __typename: 'OfflineSessionNodeEdge',
                node: newOfflineSessionRef,
              });
            }

            return {
              __typename: existingOfflineSessions.__typeName,
              edges,
            };
          },
        },
      });
    },
  });
}
